import { useRef } from 'react'
import { Formik } from 'formik'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Input
} from '@cutilei/ui'
import deleteBillValidator from 'validators/deleteBillValidator'

const formStyle = {display: 'flex', flexDirection: 'column', gap: 16}

/*
  Pede o motivo antes de excluir uma comanda, sobre o AlertDialog do @cutilei/ui. O foco abre no
  campo do motivo, e o Enter nele confirma pelo Formik, como o botão: o `<form>` tem `onSubmit`, e
  nada recarrega a página.
*/
export default function DeleteBillDialog({
  visible,
  title = 'Excluir comanda',
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const reasonRef = useRef(null)

  return (
    <AlertDialog open={Boolean(visible)} onOpenChange={open => { if (!open) handleClose() }}>
      <AlertDialogContent
        onOpenAutoFocus={event => {
          event.preventDefault()
          reasonRef.current?.focus()
        }}
      >
        <Formik
          validationSchema={deleteBillValidator}
          initialValues={{delete_reason: ''}}
          onSubmit={values => {
            handleConfirm(values.delete_reason)
            handleClose()
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
            <form noValidate onSubmit={handleSubmit} style={formStyle}>
              <AlertDialogHeader>
                <AlertDialogTitle>{title}</AlertDialogTitle>
                <AlertDialogDescription>
                  Se deseja excluir esta comanda, insira o motivo da exclusão no campo abaixo.
                </AlertDialogDescription>
              </AlertDialogHeader>
              <Input
                ref={reasonRef}
                label='Motivo'
                name='delete_reason'
                maxLength={64}
                counter
                value={values.delete_reason}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.delete_reason && errors.delete_reason}
              />
              <AlertDialogFooter>
                <AlertDialogCancel>Cancelar</AlertDialogCancel>
                <AlertDialogAction
                  destructive
                  onClick={event => {
                    // Quem fecha é o onSubmit, depois da validação.
                    event.preventDefault()
                    handleSubmit()
                  }}
                >
                  Confirmar
                </AlertDialogAction>
              </AlertDialogFooter>
            </form>
          )}
        </Formik>
      </AlertDialogContent>
    </AlertDialog>
  )
}
